import React from "react";

import cx from "classnames";

import { CardTags } from "./CardTags";
import styles from "./NestingCard.scss";
import { TagType } from "./types";

/**
 * Props for the NestingCard component.
 */
interface NestingCardProps {
  /**
   * Component that will be rendered inside the main card area.
   */
  primaryComponent: React.ReactNode;
  /**
   * Component that will be rendered on top of the main card area.
   */
  secondaryComponent: React.ReactNode;
  /**
   * Optional component that will be rendered behind but above the secondaryComponent.
   */
  tertiaryComponent?: React.ReactNode;
  /**
   * Optional array of objects for tags with default styling.
   */
  tags?: TagType[];
  /**
   * It will render as a data-testid prop on the Nesting Card Component.
   */
  testId?: string;
  /**
   * Optional class name applied to the NestingCard component.
   */
  className?: string;
  primaryComponentClassName?: string;
  secondaryComponentClassName?: string;
  tertiaryComponentClassName?: string;
}

export function NestingCard({
  primaryComponent,
  secondaryComponent,
  tertiaryComponent = undefined,
  tags = [],
  testId = "nesting-card-test-id",
  className = "",
  primaryComponentClassName = "",
  secondaryComponentClassName = "",
  tertiaryComponentClassName = "",
}: NestingCardProps) {
  return (
    <div
      className={cx(styles["nesting-card-wrapper"], className)}
      data-testid={testId}
    >
      {Boolean(tertiaryComponent) && (
        <div
          className={cx(
            styles["nesting-card-tertiary"],
            tertiaryComponentClassName
          )}
        >
          {tertiaryComponent}
        </div>
      )}
      <div
        className={cx(
          styles["nesting-card-secondary"],
          secondaryComponentClassName
        )}
      >
        <div>{secondaryComponent}</div>
        <div className={styles["tags-wrapper"]}>
          <CardTags tags={tags} />
        </div>
      </div>
      <div
        className={cx(
          styles["nesting-card-primary"],
          primaryComponentClassName
        )}
      >
        {primaryComponent}
      </div>
    </div>
  );
}
